// extracted by mini-css-extract-plugin
export var stepActive = "_2r-3";
export var stepCompleted = "_2r-4";
export var stepConnectorLine = "_2r-b";
export var stepIndicatorCircle = "_2r-6";
export var stepIndicatorCircleCompleted = "_2r-7";
export var stepIndicatorCircleDefault = "_2r-8";
export var stepIndicatorTextCompleted = "_2r-9";
export var stepIndicatorTextDefault = "_2r-a";
export var stepPending = "_2r-5";
export var wizardContainer = "_2r-1";
export var wizardContent = "_2r-2";
export var wizardModal = "_2r-0";